import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function RestaurantModal({ restaurant, onClose }) {
  if (!restaurant) return null;
  return (
    <Transition appear show={!!restaurant} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-[9999] overflow-y-auto"
        onClose={onClose} // enables overlay and Escape key dismiss
      >
        <div className="flex min-h-screen items-center justify-center px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-50"
            leave="ease-in duration-200"
            leaveFrom="opacity-50"
            leaveTo="opacity-0"
          >
            <div
              className="fixed inset-0 bg-black bg-opacity-50"
              onClick={onClose}
              aria-hidden="true"
            />
          </Transition.Child>

          <span className="inline-block h-screen align-middle" aria-hidden="true">&#8203;</span>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="relative inline-block w-full max-w-md p-6 my-8 overflow-auto text-left align-middle bg-[#1F2A36] text-white rounded-lg shadow-xl z-[9999] pointer-events-auto">
              
              {/* Close ("X") button */}
              <button
                type="button"
                className="absolute top-3 right-3 text-white hover:text-gray-300 rounded-full p-1 bg-black bg-opacity-30 hover:bg-opacity-60 transition"
                onClick={onClose}
                aria-label="Close modal"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="M6 6l12 12M18 6l-12 12"/>
                </svg>
              </button>

              <Dialog.Title as="h3" className="text-xl font-semibold mb-4">
                {restaurant.name}
              </Dialog.Title>

              {/* Thumbnail */}
              {restaurant.images && restaurant.images.length > 0 && (
                <img
                  src={restaurant.images[0].asset.url}
                  alt={restaurant.name}
                  className="w-full h-40 object-cover rounded mb-4"
                />
              )}

              {/* Meta Data */}
              <div className="text-sm mb-4 space-y-2">
                <div><strong>Service Type:</strong> {restaurant.serviceType}</div>
                <div><strong>Price:</strong> {restaurant.priceRange}</div>
                <div><strong>Area:</strong> {restaurant.area}</div>
              </div>

              {/* Short Description */}
              {restaurant.shortDescription && (
                <p className="text-sm mb-4">{restaurant.shortDescription}</p>
              )}

              {/* View Full Profile */}
              <div className="text-center">
                <a
                  href={`/restaurants/${restaurant.slug?.current || restaurant.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary-compact"
                  style={{ pointerEvents: 'auto' }}
                >
                  View Full Profile ↗
                </a>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}


